// src/hooks/useStatsCard.js
import { useState, useMemo } from "react";
import { getValueProperty } from "../../utils/refund";

export const useStatsCard = ({ totalCreditRefunded, user }) => {
    const [show, setShow] = useState(false);

    const totalAmount = useMemo(() => {
        if (!totalCreditRefunded || totalCreditRefunded.length === 0) return 0;
        return totalCreditRefunded.reduce((acc, curr) => {
            const property = getValueProperty(curr);
            return acc + (property ? curr[property] || 0 : 0);
        }, 0);
    }, [totalCreditRefunded]);

    const formattedTotal = useMemo(() => {
        if (user) {
            // return totalAmount.toLocaleString();
            if (totalAmount >= 1000000) {
                return `${(totalAmount / 1000000).toFixed(2)}M`;
            } else if (totalAmount >= 1000) {
                return `${(totalAmount / 1000).toFixed(0)}K`;
            }
        }
        if (totalAmount >= 1000000) {
            return `${(totalAmount / 1000000).toFixed(2)}M`;
        } else if (totalAmount >= 1000) {
            return `${(totalAmount / 1000).toFixed(0)}K`;
        }
        return `${totalAmount}`;
    }, [totalAmount, user]);

    const projects = useMemo(() => {
        if (!totalCreditRefunded || totalCreditRefunded.length === 0) return [];
        return totalCreditRefunded.map(item => {
            const property = getValueProperty(item);
            
            return {
                id: item._id,
                amount: property ? item[property] : 0,
            };
        });
    }, [totalCreditRefunded]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return {
        show,
        handleShow,
        handleClose,
        totalAmount,
        formattedTotal,
        projects,
    };
};
